(() => {
  const menu = document.querySelector('.menu-toggle');
  const nav = document.querySelector('#navigation');
  function closeMenu(restore = false) {
    if (!nav || !menu) return;
    nav.classList.remove('is-open');
    menu.setAttribute('aria-expanded', 'false');
    if (restore) menu.focus();
  }
  if (menu && nav) {
    menu.addEventListener('click', () => {
      const open = menu.getAttribute('aria-expanded') !== 'true';
      menu.setAttribute('aria-expanded', String(open));
      nav.classList.toggle('is-open', open);
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) closeMenu(true);
    });
    document.addEventListener('click', e => { if (!e.target.closest('.nav')) closeMenu(); });
  }
  document.documentElement.classList.add('enhanced');
  const grid = document.querySelector('.product-grid');
  // The shared wrapper also serves product pages, where category links navigate normally.
  if (!grid) return;
  const cards = [...grid.querySelectorAll('.card')];
  const filters = [...document.querySelectorAll('[data-filter]')];
  const more = document.querySelector('.load-more');
  const sort = document.querySelector('#sort');
  const status = document.querySelector('#result-status');
  if (!more || !sort || !status) return;
  const categories = new Set(cards.map(c => c.dataset.category));
  let active = 'all', limit = 12;
  // Preserve the catalog order independently of featured-rail edits.
  const selectedHandles = new Set(["braided-silver-bangle", "needlepoint-turquoise-ring", "multi-stone-inlay-wedding-vase-pendant", "white-water-turquoise-squash-blossom", "zuni-half-moon-earrings", "white-buffalo-and-sleeping-beauty-turquoise-naja-necklace", "kingman-turquoise-squash-blossom", "federico-royston-turquoise-cuff"]);
  // Use Liquid's numeric minor units, never parse localized currency text.
  const priceOf = c => Number(c.dataset.price);
  const priceTier = c => priceOf(c) <= 100000 ? 0 : priceOf(c) <= 400000 ? 1 : 2;
  const byPrice = items => [...items].sort((a, b) => priceOf(a) - priceOf(b));
  const mix = items => {
    const buckets = [...categories].map(k => items.filter(c => c.dataset.category === k)).filter(b => b.length).sort((a, b) => priceOf(a[0]) - priceOf(b[0]));
    const out = [];
    while (buckets.some(b => b.length)) buckets.forEach(b => { if (b.length) out.push(b.shift()); });
    return out;
  };
  [0, 1, 2].flatMap(tier => {
    const items = byPrice(cards.filter(c => priceTier(c) === tier));
    return [...mix(items.filter(c => !selectedHandles.has(c.dataset.handle))), ...mix(items.filter(c => selectedHandles.has(c.dataset.handle)))];
  }).forEach((c, i) => { c.dataset.order = i; });
  const rail = document.querySelector('.selection-track');
  const prev = document.querySelector('.rail-prev'), next = document.querySelector('.rail-next');
  if (rail && prev && next) {
    const railState = () => {
      prev.disabled = rail.scrollLeft < 2;
      next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
    };
    const moveRail = direction => rail.scrollBy({left: direction * (rail.clientWidth + 24), behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth'});
    prev.addEventListener('click', () => moveRail(-1));
    next.addEventListener('click', () => moveRail(1));
    rail.addEventListener('scroll', railState, {passive: true});
    window.addEventListener('resize', railState);
    railState();
  }
  function render() {
    const matching = cards.filter(c => active === 'all' || c.dataset.category === active);
    matching.sort((a, b) => sort.value === 'low' ? priceOf(a) - priceOf(b) : sort.value === 'high' ? priceOf(b) - priceOf(a) : sort.value === 'name' ? a.querySelector('h3').textContent.localeCompare(b.querySelector('h3').textContent) : Number(a.dataset.order) - Number(b.dataset.order));
    cards.forEach(c => { c.hidden = true; });
    matching.forEach((c, i) => { c.style.order = i; c.hidden = i >= limit; grid.append(c); });
    filters.forEach(a => {
      if (a.dataset.filter === active) a.setAttribute('aria-current', 'true');
      else a.removeAttribute('aria-current');
    });
    const shown = Math.min(limit, matching.length);
    status.textContent = `${shown} of ${matching.length} pieces`;
    more.hidden = shown >= matching.length;
    more.textContent = `View ${Math.min(12, matching.length - shown)} more pieces`;
    more.setAttribute('aria-label', `${more.textContent}, ${matching.length - shown} remaining`);
  }
  function selectCategory(value, scroll = true) {
    active = categories.has(value) ? value : 'all';
    limit = 12; render(); closeMenu();
    if (scroll) document.querySelector('#catalog').scrollIntoView({behavior: 'instant'});
  }
  [...filters, ...document.querySelectorAll('[data-category-link]')].forEach(a => a.addEventListener('click', e => {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    e.preventDefault();
    // Category changes are same-page state; retain campaign and click parameters.
    const destination = new URL(window.location.href);
    destination.hash = new URL(a.href).hash;
    history.pushState(null, '', destination.href);
    selectCategory(a.dataset.filter || a.dataset.categoryLink);
  }));
  document.querySelectorAll('a[href="#catalog"]:not([data-filter])').forEach(a => a.addEventListener('click', () => selectCategory('all', false)));
  more.addEventListener('click', () => {
    const before = new Set(cards.filter(c => !c.hidden));
    limit += 12; render();
    const firstNew = cards.filter(c => !c.hidden && !before.has(c)).sort((a, b) => Number(a.style.order) - Number(b.style.order))[0];
    if (firstNew) firstNew.focus({preventScroll: true});
  });
  sort.addEventListener('change', () => { limit = 12; render(); });
  window.addEventListener('hashchange', () => selectCategory(location.hash.slice(1), false));
  window.addEventListener('popstate', () => selectCategory(location.hash.slice(1), false));
  selectCategory(location.hash.slice(1), categories.has(location.hash.slice(1)));
})();
